<mat-dialog-title style="padding: 8px 12px;">
    <div class="dialog-title-container">
        <button mat-icon-button mat-dialog-close (click)="onCloseDialog()">
            <mat-icon class="close-icon">close</mat-icon>
        </button>
    </div>
</mat-dialog-title>

<mat-dialog-content class="dialog-container">
    <div>
        <div class="icon-container">
            <img src="assets/images/submission-success.svg" alt="Submission Successful Icon" />
          </div>
          

        <h2 class="dialog-title-text">Your application has been submitted!</h2>
        <p class="dialog-message">
            Use your profile to check on updates for this application.
        </p>

        <div class="popup-container">
            <button class="button-Primary" (click)="Submit()" >CONTINUE TO HOME</button>
          </div>
          
    </div>
</mat-dialog-content>